module.exports = __webpack_public_path__ + "img/camera.5f38e7ca.svg";